import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { getFormValues, blur, touch, change } from 'redux-form';
import classNames from 'classnames';
import _ from 'lodash';

import Button from 'jbc-front/components/Button';
import { Section, TextField, SelectField, RadioField } from 'src/jbc-front/components/Form';
import { IS_SHOW, SEMI_MONTHLY_TAX_DEDUCTION_OPTIONS, PAYMENT_COUNT_OPTIONS } from 'src/constants/Options';
import { PAYROLL_RULES_GROUP_FORM } from 'src/constants/FormNames';
import { CLIENT_PAYROLL_RULES_GROUP_LIST } from 'src/constants/EndpointUrls';
import { isHourFormat, isFloatFormat, isProbationDaysValid } from 'src/utils/CustomValidators';
import { toHourFormat, toFloatFormat, toDisplayFormat, toDbFormat } from 'src/utils/Completion';
import { convertTimeToMinutes, formatMinutesToTime } from 'src/utils/Number';
import * as CssClassNames from 'src/constants/CssClassNames';
import { getSelectOptions, getRadioOptions, getLabeledDays } from 'src/reducers/selectOptions';
import { FormErrors } from 'src/components';
import { CancelBtn } from 'src/buttons';
import { scrollToTop } from 'src/utils/Utils';

import { changeRadioLabel, validateFormInput } from '../PayrollRulesGroupsUtils';
import ConfirmModal from '../components/ConfirmModal';
import ErrorModal from '../components/ErrorModal';
import SemiMonthlyPreview from '../components/SemiMonthlyPreview';
import FirstHalfSetting from '../components/FirstHalfSetting';
import SecondHalfSetting from '../components/SecondHalfSetting';
import PaymentTermSetting from '../components/PaymentTermSetting';

class PayrollRulesGroupForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isApplicableSsoRateMonth: this.props.initialValues.applicableSsoRateMonth !== 'not_applicable',
      onOpenModal: false,
      confirmData: this.props.initialValues,
      newSalaryRuleData: this.props.initialValues,
      errorInput: [],
      cancel: true,
      language: this.props.i18n.language,
      payrollTypes: this.props.payrollTypes,
      paymentMonthTypes: this.props.paymentMonthTypes,
      applicableSsoRateMonth: this.props.applicableSsoRateMonth,
      displayMonthNameTypes: this.props.displayMonthNameTypes,
      optionOnOff: IS_SHOW
    };
  }
  complementAvgRegularWorkingHoursPerMonth(prescribedWorkingHoursPerDay, avgRegularWorkingDaysPerMonth) {
    const { dispatch } = this.props;
    const avgRegularWorkingHoursPerMonth = formatMinutesToTime(
      convertTimeToMinutes(prescribedWorkingHoursPerDay) * avgRegularWorkingDaysPerMonth
    );
    dispatch(change(PAYROLL_RULES_GROUP_FORM, 'avgRegularWorkingHoursPerMonth', avgRegularWorkingHoursPerMonth));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.i18n.language !== this.state.language) {
      const { payrollTypes, paymentMonthTypes, applicableSsoRateMonth, displayMonthNameTypes } = changeRadioLabel(
        prevProps.i18n.language,
        this.props
      );
      // ESLint doesn't allow to use this.setState in componentDidUpdate function
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        payrollTypes,
        paymentMonthTypes,
        applicableSsoRateMonth,
        displayMonthNameTypes,
        language: prevProps.i18n.language
      });
    }
    // @TODO: Temporarily hide twice monthly payment feature, will be developed later
    // https://donuts-vn.atlassian.net/browse/JBC-92
    // if (prevProps.formValues.paymentCount !== this.props.selectedPaymentCount) {
    //   this.props.dispatch(change(PAYROLL_RULES_GROUP_FORM, 'closingDay', null));
    //   this.props.dispatch(change(PAYROLL_RULES_GROUP_FORM, 'paymentDay', null));
    //   this.props.dispatch(change(PAYROLL_RULES_GROUP_FORM, 'closingDaySecondHalf', null));
    //   this.props.dispatch(change(PAYROLL_RULES_GROUP_FORM, 'paymentDaySecondHalf', null));
    //   this.props.dispatch(change(PAYROLL_RULES_GROUP_FORM, 'firstHalfStartDate', null));
    // }

    // @TODO: Temporarily hide twice monthly payment feature, will be developed later
    // https://donuts-vn.atlassian.net/browse/JBC-92
    // if (this.props.selectedPaymentCount === 'twice' && !prevProps.formValues.applicableSsoRateMonth) {
    //   this.props.dispatch(change(PAYROLL_RULES_GROUP_FORM, 'applicableSsoRateMonth', 'prev_month'));
    // }

    if (prevProps.errors.length !== this.props.errors.length && this.props.errors.length > 0) {
      scrollToTop();
    }
  }

  render() {
    const {
      handleSubmit,
      submit,
      hasConfirmedPays,
      errors,
      days,
      prescribedWorkingHoursPerDay,
      avgRegularWorkingDaysPerMonth,
      dispatch,
      pristine,
      submitting,
      isCopyForm,
      formValues,
      selectedPaymentCount,
      t
    } = this.props;

    const detectCutoffDay = (e, newValue) => {
      if (newValue === 31) {
        this.setState({ isApplicableSsoRateMonth: false });
        dispatch(change(PAYROLL_RULES_GROUP_FORM, 'applicableSsoRateMonth', 'not_applicable'));
      } else {
        this.setState({ isApplicableSsoRateMonth: true });
        dispatch(change(PAYROLL_RULES_GROUP_FORM, 'applicableSsoRateMonth', null));
      }
    };

    const applicableSsoRateMonthField =
      this.state.isApplicableSsoRateMonth === true
        ? this.state.applicableSsoRateMonth.filter(val => val.numberValue !== 3)
        : this.state.applicableSsoRateMonth;

    const isNewSalaryRule = () => window.location.pathname === '/clients/payroll_rules_groups/new';

    const setOnOpenModal = () => {
      this.setState({
        onOpenModal: true
      });
    };

    const setOnCloseModal = () => {
      this.setState({
        onOpenModal: false
      });
    };
    const onConfirm = async () => {
      await submit();
      setOnCloseModal();
    };

    const onCancel = () => {
      setOnCloseModal();
      this.setState({
        cancel: true
      });
    };
    const checkInput = () => {
      this.setState({ errorInput: [] });
      const error = validateFormInput(formValues, this.props.t);
      this.setState({ errorInput: error });
    };

    return (
      <form className={classNames(CssClassNames.FORM, CssClassNames.CLIENT_FORM)} onSubmit={handleSubmit}>
        {isNewSalaryRule && this.state.errorInput.length === 0 ? (
          <ConfirmModal setOnCloseModal={setOnCloseModal} onOpenModal={this.state.onOpenModal} onCancel={onCancel} onConfirm={onConfirm} />
        ) : (
          <ErrorModal errorInput={this.state.errorInput} setOnCloseModal={setOnCloseModal} onOpenModal={this.state.onOpenModal} />
        )}
        <FormErrors errors={errors} />
        <Section>
          <TextField required label={t('features.EmployeePays.components.DownloadColumnDetail.salary_rules_group_name')} name="name" />
          <RadioField
            required
            label={t('features.Employees.components.PayrollRulenInfo.form_of_salary')}
            name="payrollType"
            options={this.state.payrollTypes}
          />
          <RadioField
            required
            label={t('features.Employees.components.PayrollRulenInfo.payment_count')}
            name="paymentCount"
            options={PAYMENT_COUNT_OPTIONS}
            disabled={hasConfirmedPays}
          />
          <TextField
            label={t('features.Employees.components.PayrollRulenInfo.designated_working_hours_in_one_day')}
            name="prescribedWorkingHoursPerDay"
            validate={[isHourFormat]}
            onBlur={(e, newValue, previousValue) => {
              e.preventDefault();
              dispatch(blur(PAYROLL_RULES_GROUP_FORM, 'prescribedWorkingHoursPerDay', toHourFormat(previousValue)));
              dispatch(touch(PAYROLL_RULES_GROUP_FORM, 'prescribedWorkingHoursPerDay'));

              this.complementAvgRegularWorkingHoursPerMonth(toHourFormat(previousValue), avgRegularWorkingDaysPerMonth);
            }}
          />

          <TextField
            label={t('features.Employees.components.PayrollRulenInfo.average_designated_working_days_in_one_month')}
            name="avgRegularWorkingDaysPerMonth"
            format={toDisplayFormat}
            validate={[isFloatFormat]}
            onBlur={(e, newValue, previousValue) => {
              e.preventDefault();
              const dbValue = toFloatFormat(toDbFormat(previousValue));
              dispatch(blur(PAYROLL_RULES_GROUP_FORM, 'avgRegularWorkingDaysPerMonth', dbValue));
              dispatch(touch(PAYROLL_RULES_GROUP_FORM, 'avgRegularWorkingDaysPerMonth'));

              this.complementAvgRegularWorkingHoursPerMonth(prescribedWorkingHoursPerDay, dbValue);
            }}
          />

          <TextField
            label={t('features.Employees.components.PayrollRulenInfo.average_designated_working_hours_in_one_month')}
            name="avgRegularWorkingHoursPerMonth"
            validate={[isHourFormat]}
            onBlur={(e, newValue, previousValue) => {
              e.preventDefault();
              dispatch(blur(PAYROLL_RULES_GROUP_FORM, 'avgRegularWorkingHoursPerMonth', toHourFormat(previousValue)));
              dispatch(touch(PAYROLL_RULES_GROUP_FORM, 'avgRegularWorkingHoursPerMonth'));
            }}
          />

          <TextField
            label={t('features.Employees.components.PayrollRulenInfo.probation_days_required')}
            validate={[isProbationDaysValid]}
            name="probationDaysRequired"
            onBlur={(e, newValue) => {
              e.preventDefault();
              if (!newValue || newValue.trim() === '') {
                dispatch(change(PAYROLL_RULES_GROUP_FORM, 'probationDaysRequired', 0));
              }
            }}
          />
          {/* @TODO: Temporarily hide twice monthly payment feature, will be developed later
            https://donuts-vn.atlassian.net/browse/JBC-92 */}
          {/* {selectedPaymentCount === 'twice' && (
            <>
              <PaymentTermSetting disabled={hasConfirmedPays} />
              <FirstHalfSetting />
              <SecondHalfSetting />
              <SemiMonthlyPreview title="preview_setting" />
            </>
          )} */}

          {selectedPaymentCount !== 'twice' && (
            <>
              <SelectField
                required
                label={t('features.Employees.components.PayrollRulenInfo.cutoff_date')}
                name="closingDay"
                options={days}
                disabled={hasConfirmedPays}
                onChange={detectCutoffDay}
              />
              <RadioField
                required
                label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.payment_date_month')}
                name="paymentMonthType"
                options={this.state.paymentMonthTypes}
                disabled={hasConfirmedPays}
              />
              <SelectField
                required
                label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.payment_date_day')}
                name="paymentDay"
                options={days}
                disabled={hasConfirmedPays}
              />
              <RadioField
                required
                label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.month_of_the_applicable_sso_calculation_rate')}
                name="applicableSsoRateMonth"
                options={applicableSsoRateMonthField}
                disabled={this.state.isApplicableSsoRateMonth !== true || hasConfirmedPays}
                note={
                  <p>
                    {t(
                      'features.PayrollRulesGroups.containers.PayrollRulesGroupForm.month_of_the_applicable_SSO_calculation_rate_can_be_set_here'
                    )}
                    <br />
                    {t(
                      'features.PayrollRulesGroups.containers.PayrollRulesGroupForm.i_e_If_the_payroll_is_2021_2_20_closure_2021_3_25_payment'
                    )}
                    <br />
                    {t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.working_period_2021_1_21_2021_2_20')}
                    <br />
                    {t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.payment_date_2021_3_25')}
                    <br />
                    {t(
                      'features.PayrollRulesGroups.containers.PayrollRulesGroupForm.Choose_Month_of_the_first_day_worked_during_the_payroll_period'
                    )}
                    <br />
                    {t(
                      'features.PayrollRulesGroups.containers.PayrollRulesGroupForm.Choose_Month_of_the_last_day_worked_during_the_payroll_period'
                    )}
                    <br />
                    {t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.If_the_closure_date_is_set_at_the_end_of_the_month')}
                  </p>
                }
                noteWidth={700}
              />
            </>
          )}

          <RadioField
            required
            label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.Month_shown_in_payslip')}
            name="displayMonthNameType"
            options={this.state.displayMonthNameTypes}
            note={
              <p>
                {t(
                  'features.PayrollRulesGroups.containers.PayrollRulesGroupForm.Can_set_the_month_shown_in_payslip_as_YYYY_MM_payslip_format'
                )}
                <br />
                {t(
                  'features.PayrollRulesGroups.containers.PayrollRulesGroupForm.For_example_salary_which_is_closed_in_2018_6_and_paid_at_7_15_will_be_shown_as_follows'
                )}
                <br />
                {t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.If_month_of_payment_date_is_selected_2018_7_payslip')}
                <br />
                {t(
                  'features.PayrollRulesGroups.containers.PayrollRulesGroupForm.If_previous_month_of_payment_date_is_selected_2018_6_payslip'
                )}
              </p>
            }
            noteWidth={550}
          />
          <RadioField
            required
            label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.is_show_attendance')}
            name="isShowAttendance"
            options={this.state.optionOnOff}
          />

          {/* @TODO: Hide Provident Fund for Vietnam */}
          {/* https://donuts-vn.atlassian.net/browse/JBC-25 */}
          {/*
            <RadioField
              required
              label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.is_show_provident_fund')}
              name="isShowProvidentFund"
              options={this.state.optionOnOff}
            /> */}
          {/* @TODO: Temporarily hide twice monthly payment feature, will be developed later
            https://donuts-vn.atlassian.net/browse/JBC-92
          */}
          {/* {selectedPaymentCount === 'twice' && (
            <>
              <RadioField
                required
                label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.timing_of_tax_deduction')}
                name="timingOfTaxDeduction"
                options={SEMI_MONTHLY_TAX_DEDUCTION_OPTIONS}
              />
            </>
          )} */}
        </Section>
        <div className="u-ta-c">
          <CancelBtn href={CLIENT_PAYROLL_RULES_GROUP_LIST} className="u-mr20" />
          <Button
            as="button"
            onClick={() => {
              checkInput();
              setOnOpenModal();
            }}
            type="button"
            disabled={(!isCopyForm && pristine) || (submitting && !this.state.cancel)}
            primary
          >
            {t('features.EmployeeBonus.components.ActionButtonSection.save')}
          </Button>
        </div>
      </form>
    );
  }
}

const mapStateToProps = state => ({
  payrollTypes: getSelectOptions(state, 'payrollTypes'),
  paymentMonthTypes: getSelectOptions(state, 'paymentMonthTypes'),
  displayMonthNameTypes: getRadioOptions(state, 'displayMonthNameTypes'),
  days: getLabeledDays(state),
  prescribedWorkingHoursPerDay: _.get(getFormValues(PAYROLL_RULES_GROUP_FORM)(state), 'prescribedWorkingHoursPerDay'),
  avgRegularWorkingDaysPerMonth: _.get(getFormValues(PAYROLL_RULES_GROUP_FORM)(state), 'avgRegularWorkingDaysPerMonth'),
  hasConfirmedPays: _.get(getFormValues(PAYROLL_RULES_GROUP_FORM)(state), 'hasConfirmedPays'),
  applicableSsoRateMonth: getRadioOptions(state, 'applicableSsoRateMonth'),
  formValues: getFormValues(PAYROLL_RULES_GROUP_FORM)(state),
  selectedPaymentCount: _.get(getFormValues(PAYROLL_RULES_GROUP_FORM)(state), 'paymentCount')
});
export default withTranslation()(connect(mapStateToProps)(PayrollRulesGroupForm));
